// Notification Coordinator Types
// ✅ NO MAGIC STRINGS: Use typed enums and constants

export enum NotificationSeverity {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

export enum NotificationEvent {
  NOTIFICATION_SHOW = "notification_show",
  NOTIFICATION_HIDE = "notification_hide",
  NOTIFICATION_CLEAR = "notification_clear",
  NOTIFICATION_UPDATE = "notification_update",
  NOTIFICATION_BATCH = "notification_batch",
}

export enum NotificationAction {
  SHOW = "show",
  HIDE = "hide",
  CLEAR = "clear",
  UPDATE = "update",
  BATCH = "batch",
}

export interface NotificationPayload {
  id?: string;
  message: string;
  severity: NotificationSeverity;
  duration?: number;
  action?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata?: Record<string, any>;
  timestamp?: Date;
}

export interface NotificationState {
  id: string;
  message: string;
  severity: NotificationSeverity;
  open: boolean;
  duration: number;
  action?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata?: Record<string, any>;
  timestamp: Date;
  timeoutId?: NodeJS.Timeout;
}

export interface NotificationConfig {
  defaultDuration: number;
  maxNotifications: number;
  enableAutoHide: boolean;
  enableSound: boolean;
  enableVibration: boolean;
  position: NotificationPosition;
}

export enum NotificationPosition {
  TOP_LEFT = "top-left",
  TOP_RIGHT = "top-right",
  TOP_CENTER = "top-center",
  BOTTOM_LEFT = "bottom-left",
  BOTTOM_RIGHT = "bottom-right",
  BOTTOM_CENTER = "bottom-center",
}

export interface NotificationMetrics {
  totalShown: number;
  totalHidden: number;
  totalCleared: number;
  activeNotifications: number;
  averageDuration: number;
  errorCount: number;
  successCount: number;
  warningCount: number;
  infoCount: number;
}

export interface NotificationBatch {
  notifications: NotificationPayload[];
  batchId: string;
  timestamp: Date;
}

export const NOTIFICATION_ERRORS = {
  INVALID_SEVERITY: "Invalid notification severity",
  INVALID_DURATION: "Invalid notification duration",
  MAX_NOTIFICATIONS_EXCEEDED: "Maximum notifications exceeded",
  NOTIFICATION_NOT_FOUND: "Notification not found",
  BATCH_EMPTY: "Notification batch is empty",
  INVALID_POSITION: "Invalid notification position",
} as const;

export type NotificationErrorType = keyof typeof NOTIFICATION_ERRORS;

export class NotificationError extends Error {
  constructor(
    public readonly type: NotificationErrorType,
    public readonly details?: string,
  ) {
    super(NOTIFICATION_ERRORS[type]);
    this.name = "NotificationError";
  }
}
